<template>
  <div class="footers">
    <div class="fontcontent">
      <div class="imgs">
        <ul>
          <li class="libom">
            <!-- 联系我们 -->
            {{$t('footer.Services')}}
          </li>
          <li>
            <span style="font-size:18px;color:#ccc;">{{$t('footer.phonetext')}}</span>
          </li>
          <li>
            <p style="color: #136c66;font-size: 24px;">{{$t('footer.telphone')}}</p>
          </li>
          <li style="height:18px;"></li>
        
          <li>
            <span>{{$t('footer.email')}}</span>
          </li>
              <li>
            <span>{{$t('footer.saleemail')}}</span>
          </li>
            <li style="height:45px;">
            <span>{{$t('footer.address')}}</span>
          </li>
        </ul>
      </div>
      <div class="footercontent">
        <div class="headerconts">
          <ul>
            <li class="libom">
              {{$t('footer.productSystem')}}
            </li>
            <li class="cus" @click="tap1">{{$t('footer.DCIInterconnected')}}</li>
            <li class="cus" @click="tap2">{{$t('footer.CloudLine')}}</li>
            <li class="cus" @click="tap3">{{$t('footer.DirectionalAcceleration')}}</li>
            <li class="cus" @click="tap4">{{$t('footer.SDWAN')}}</li>
          </ul>
          <ul>
            <li class="libom">
               {{$t('footer.solution')}}
            </li>
            <li class="cus" @click="tap5">{{$t('footer.cloud')}}</li>
            <li class="cus" @click="tap6">{{$t('footer.conty')}}</li>
            <li class="cus"></li>
            <li class="cus"></li>
          </ul>
          <ul>
            <li class="libom">
              {{$t('footer.about')}}
            </li>
            <li class="cus" @click="tap7">{{$t('footer.intro')}}</li>
            <li class="cus" @click="tap8">{{$t('footer.service')}}</li>
            <li class="cus"></li>
            <li class="cus"></li>
          </ul>
        </div>
      </div>
      <div class="footercontent">
        <div class="headerconts" style="width:240px;">
          <div class="wx">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    tap1() {
      this.$router.push({
        path: "/product"
      });
    },
    tap2() {
      this.$router.push({
        path: "/product2"
      });
    },
     tap3() {
      this.$router.push({
        path: "/product3"
      });
    },
     tap4() {
      this.$router.push({
        path: "/product4"
      });
    },
     tap5() {
      this.$router.push({
        path: "/solution"
      });
    },
     tap6() {
      this.$router.push({
        path: "/solutegrop"
      });
    },
     tap7() {
      this.$router.push({
        path: "/aboutus"
      });
    },
     tap8() {
      this.$router.push({
        path: "/service"
      });
    }
  }
};
</script>
<style lang="scss">
.footers {
  width: 100%;
  margin: 0 auto;
  background-color: #011801;
  background-size: 100% 100%;
  color: #fff !important;
  padding-bottom: 20px;
  .fontcontent {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .imgs {
      width: 390px;
      ul {
        font-size: 16px;
        text-align: left;
        margin-top: 80px;
        margin-right: 30px;
        li {
          font-size: 12px;
          height: 28px;
          color: #ccc;
        }
        .libom {
          color: #fff;
          font-size: 16px;
          margin-bottom: 26px;
        }
        .cus {
          cursor: pointer;
        }
        .qq {
          display: inline-block;
          height: 24px;
          line-height: 24px;
          border: 1px solid #2a99fc;
          background: #2a99fc;
          border-radius: 3px;
          padding: 0 10px;
          margin-top: 20px;
        }
      }
    }
  }

  .footercontent {
    .headerconts {
      display: flex;
      justify-content: space-around;
      align-items: center;
      ul {
        font-size: 16px;
        text-align: left;
        margin-top: 80px;
        margin-right: 60px;
        // width: 70px;
        li {
          font-size: 12px;
          height: 30px;
          color: #ccc;
        }
        .libom {
          color: #fff;
          font-size: 16px;
          margin-bottom: 26px;
        }
        .cus {
          cursor: pointer;
        }
        .qq {
          display: inline-block;
          height: 24px;
          line-height: 24px;
          border: 1px solid #2a99fc;
          background: #2a99fc;
          border-radius: 3px;
          padding: 0 10px;
          margin-top: 20px;
        }
      }
    }
    .wx {
      .fotpas {
        box-sizing: border-box;
        img {
          width: 242px;
	        height: 183px;
          vertical-align: middle;
        }
      }
      .test {
        font-size: 14px;
      }
    }
  }
}
</style>
